module.exports = __webpack_public_path__ + "static/media/createReturnOrderScreen.1212e285.png";